import { fetchJSON, querySelectorAll } from '../helpers'

interface FeedbackResponse {
  message: 'success' | 'failure'
}

function validateForms() {
  querySelectorAll<HTMLFormElement>('.feedback_form').forEach(form => {
    let valid = true
    querySelectorAll<HTMLInputElement>('input[required]', form).forEach(
      input => {
        if (!input.value) {
          valid = false
        }
      }
    )
    const submitButton: HTMLButtonElement | null = form.querySelector(
      'button[type="submit"]'
    )
    if (submitButton) {
      submitButton.disabled = !valid
    }
  })
}

function clearForms() {
  querySelectorAll<HTMLFormElement>('.feedback_form').forEach(form => {
    form.reset()
  })

  validateForms()
}

function initializeForms() {
  querySelectorAll<HTMLFormElement>('.feedback_form').forEach(form => {
    querySelectorAll<HTMLInputElement>('input[required]', form).forEach(
      input => {
        input.addEventListener('change', validateForms)
        input.addEventListener('keyup', validateForms)
        input.addEventListener('keydown', validateForms)
      }
    )

    form.addEventListener('submit', async e => {
      e.preventDefault()
      const params: any = {
        Link: window.location.pathname,
        AbsoluteLink: window.location.href,
      }
      querySelectorAll<HTMLInputElement>('input', form).forEach(input => {
        params[input.name] = input.value
      })
      querySelectorAll<HTMLTextAreaElement>('textarea', form).forEach(textarea => {
        params[textarea.name] = textarea.value
      })

      const response: FeedbackResponse = await fetchJSON(
        '/feedback',
        'POST',
        params
      )
      if (response.message === 'success') {
        clearForms()
        showThankyou(form.id)
      }
    })
  })
}

function showThankyou(formId: string) {
  const thankyou = document.querySelector(`#${formId} .feedback_thanks`)
  if (thankyou) {
    thankyou.classList.add('feedback_thanks--active')
  }
}

function hideThankyous() {
  querySelectorAll('.feedback_thanks--active').forEach(el => {
    el.classList.remove('feedback_thanks--active')
  })
}

function showForm(formId: string) {
  const formWrapper = document.querySelector('.feedback_form-wrapper')
  const options = document.querySelector('.feedback_options-wrapper')

  if (formWrapper && options) {
    querySelectorAll('.feedback_form', formWrapper).forEach(form => {
      form.classList.toggle('feedback_form--active', form.id === formId)

      if (form.id === formId && form.id === 'report-page-helpful') {
        const params: any = {}

        querySelectorAll<HTMLInputElement>('input', form).forEach(input => {
          params[input.name] = input.value
        })

        // void fetchJSON('/feedback', 'POST', params).then(() => {
        //   // showThankyou('report-page-helpful')
        // })
      }
    })

    formWrapper.classList.add('feedback_form-wrapper--active')
    options.classList.add('feedback_options-wrapper--hidden')

    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: formWrapper.getBoundingClientRect().top + window.scrollY - 10,
    })
  }
}

function closeForms() {
  const formWrapper = document.querySelector('.feedback_form-wrapper')
  const options = document.querySelector('.feedback_options-wrapper')

  if (formWrapper && options) {
    querySelectorAll('.feedback_form', formWrapper).forEach(form => {
      form.classList.remove('feedback_form--active')
    })

    formWrapper.classList.remove('feedback_form-wrapper--active')
    options.classList.remove('feedback_options-wrapper--hidden')
    hideThankyous()
  }
}

export function initializeFeedback(selector: string) {
  querySelectorAll(selector).forEach(feedback => {
    const formWrapper = feedback.querySelector('.feedback_form-wrapper')
    const options = feedback.querySelector('.feedback_options-wrapper')

    if (options && formWrapper) {
      const yesOption = options.querySelector('.feedback_options-answers--yes')
      const noOption = options.querySelector('.feedback_options-answers--no')
      const reportOption = options.querySelector(
        '.feedback_options-report-error'
      )
      const forms = querySelectorAll('.feedback_form', formWrapper)

      querySelectorAll<HTMLAnchorElement>('a', options).forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault()
          const formId = (e.currentTarget as HTMLAnchorElement).href
            .split('#')
            .pop()
          if (formId) {
            showForm(formId)
          }
        })
      })
    }

    querySelectorAll('.feedback_close', feedback).forEach(close => {
      close.addEventListener('click', e => {
        e.preventDefault()
        closeForms()
      })
    })
  })

  validateForms()
  initializeForms()
}
